export function logError(error) {
  // eslint-disable-next-line no-console
  return console.log(error);
}

export default { logError };
